import { render, staticRenderFns } from "./WorkshopsWorkshops.vue?vue&type=template&id=95864fe2&scoped=true&"
import script from "./WorkshopsWorkshops.vue?vue&type=script&lang=ts&"
export * from "./WorkshopsWorkshops.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95864fe2",
  null
  
)

export default component.exports